export default {
    customer: {
        planSelection: {
            backButton: 'Voltar',
            underOverPriceTitle: 'Verifique o "Preço para o cliente"',
            underOverPriceText:
                'O valor a cobrar do cliente está menor que o valor a pagar para a ConnectPlug. <br/><br/> Deseja continuar mesmo assim ?',
            confirmSelectionTitle: 'Confirmar Ativação do Cliente',
            confirmSelectionText:
                'Após a ativação, o plano estará disponível para o seu cliente utilizar e os valores serão cobrados no próximo vencimento do ciclo. <br/><br/> Deseja confirmar a seleção de plano ?',
        },
    },

    landingPage: {
        copy: {
            label: 'Copiar URL',
            success: 'URL copiada para área de tranferência.',
            error:
                'Sem acesso à sua área de transferência, por favor selecione a URL manualmente e pressione CTRL+C para copia-la para sua área de transferência.',
        },
    },
}
